// Action Types
export const SET_CHECKIN_STATUS = "SET_CHECKIN_STATUS";
export const SET_CHECKIN_LOCATION = "SET_CHECKIN_LOCATION";
export const SET_CHECKIN_TIME = "SET_CHECKIN_TIME"; // ✅ new

// Action Creators
export const setCheckinStatus = (status) => ({
  type: SET_CHECKIN_STATUS,
  payload: status,
});

export const setCheckinLocation = (location) => ({
  type: SET_CHECKIN_LOCATION,
  payload: location,
});

export const setCheckinTime = (time) => ({  // ✅ new
  type: SET_CHECKIN_TIME,
  payload: time,
});
